import React, { ReactNode } from 'react';
import {
  DndContext,
  DndContextProps,
  DragEndEvent,
  DragMoveEvent,
  DragOverlay,
  DragStartEvent,
  rectIntersection,
} from '@dnd-kit/core';

interface ComponentProps extends Partial<DndContextProps> {
  children: React.ReactNode;
  onDragEnd?: (event: DragEndEvent) => void;
  canScroll: boolean;
}

const DndWrapper: React.FC<ComponentProps> = ({
  children,
  onDragEnd,
  collisionDetection = rectIntersection,
  modifiers = [],
  canScroll = false,
}) => {
  const [activeItem, setActiveItem] = React.useState<any>(null);

  const handleDragStart = (event: DragStartEvent) => {
    setActiveItem(event.active.data.current);
  };

  const handleDragMove = (event: DragMoveEvent) => {
    if (!activeItem) return;

    const { active } = event;
    const currentData = active.data.current;

    const { onItemDragging } = currentData || {};
    if (typeof onItemDragging === 'function') {
      onItemDragging(event);
      setActiveItem(currentData);
    }
  };

  const handleDragEnd = (event: DragEndEvent) => {
    setActiveItem(null);

    const { active, over } = event;
    if (!active || !over) return;

    // Retrieve the custom onItemDragEnd function from the active item’s data
    const { onItemDragEnd } = active.data.current || {};
    if (typeof onItemDragEnd === 'function') {
      onItemDragEnd(event);
    }

    // Call the global onDragEnd if provided
    if (onDragEnd) {
      onDragEnd(event);
    }
  };

  return (
    <DndContext
      onDragStart={handleDragStart}
      onDragMove={handleDragMove}
      onDragEnd={handleDragEnd}
      collisionDetection={collisionDetection}
      modifiers={modifiers}
      autoScroll={canScroll}
    >
      {children}
      <DragOverlay className="dnd-overlay" dropAnimation={null}>
        {renderDragOverlay(activeItem)}
      </DragOverlay>
    </DndContext>
  );
};

function renderDragOverlay(activeItem: any): ReactNode {
  if (activeItem) return activeItem.children;
  else return null;
}

export default DndWrapper;
